import React, { useEffect, useRef, useState } from "react";
import { Modal, Input, Select, DatePicker, Radio, Button } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { CREATE_jwel } from "../Config/Config";

const { Option } = Select;

const CustomerDialog = ({
  open,
  onCancel,
  onSave,
  mode = "create", // "create" | "edit"
  lockName = false, // lock the name while the customer has a ledger balance
  formValues,
  setFormValues,
  phoneNo,
  setPhoneNo,
  userDetailsAPI,
  phone1Ref,
  searchRef,
  handleMobileNoKeyDown,
}) => {
  const tenantName = localStorage.getItem("tenantName");
  const mobileRef = useRef(null);
  const cityRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const phone2Ref = useRef(null);
  const addressRef = useRef(null);
  const stateRef = useRef(null);
  const gstRef = useRef(null);
  const panRef = useRef(null);
  const idProfRef = useRef(null);
  const dobRef = useRef(null);
  const anniversaryRef = useRef(null);
  const saveRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [stateList, setStateList] = useState([]);

  const isEdit = mode === "edit";

  const stateDetailsAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=STATE_MASTER`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setStateList(data);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  useEffect(() => {
    stateDetailsAPI();
  }, []);

  const handleChange = (field, value) => {
    if (field === "state") {
      const selected = stateList.find((s) => s.statename === value);
      setFormValues((prev) => ({
        ...prev,
        state: value,
        stateCode: selected ? selected.statecode : "",
        locationType: selected?.DEAFULTSTATE === true ? "LOCAL" : "OUTSTATION",
      }));
    } else if (field === "address") {
      // Split address text area into 4 lines
      const lines = value.split("\n");
      setFormValues((prev) => ({
        ...prev,
        address1: lines[0] || "",
        address2: lines[1] || "",
        address3: lines[2] || "",
        address4: lines[3] || "",
      }));
    } else {
      setFormValues((prev) => ({ ...prev, [field]: value }));
    }

    // Clear error when user starts typing
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSave = () => {
    const newErrors = {};

    // old customers may have odd mobile values, and the mobile is locked in edit mode
    if (!isEdit) {
      if (!formValues.mobile1.trim()) {
        newErrors.mobile1 = "Mobile number is required";
      } else if (!/^\d+$/.test(formValues.mobile1)) {
        newErrors.mobile1 = "Mobile number must contain only digits";
      } else if (formValues.mobile1.length !== 10) {
        newErrors.mobile1 = "Mobile number must be exactly 10 digits";
      } else if (!/^[6-9]/.test(formValues.mobile1)) {
        newErrors.mobile1 = "Mobile number is not corrected";
      }
    }
    if (!formValues.city.trim()) newErrors.city = "City is required";
    if (!formValues.name.trim()) newErrors.name = "Name is required";
    if (!formValues.state.trim()) newErrors.state = "State is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Stop execution if errors exist
    }

    // the parent decides between create and edit
    onSave(formValues);
  };

  useEffect(() => {
    if (open && mobileRef.current) {
      mobileRef.current.focus();
    }
  }, [open]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      className="cd-modal"
      title={<div className="cd-title">{isEdit ? "Edit Customer" : "New Customer"}</div>}
      open={open}
      onCancel={() => {
        onCancel();
        setErrors({});
      }}
      footer={null}
      closable={false}
      centered
      width={650}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        padding: "5px 5px",
      }}
      afterOpenChange={(open) => {
        if (open && mobileRef.current) {
          mobileRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .cd-modal{max-width:calc(100vw - 16px)}
        .cd-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .cd-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .cd-modal .ant-modal-body{padding:12px;background:#eef1f8;max-height:78vh;overflow-y:auto}

        .cd-title{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .cd-search{display:flex;gap:8px;align-items:center;background:linear-gradient(135deg,#1f8f6a,#52bd91);border-radius:14px;padding:10px 12px;box-shadow:0 4px 12px rgba(31,143,106,.3)}
        .cd-search-in{flex:1}
        .cd-search-btn{height:40px!important;padding:0 18px!important;border-radius:10px!important;font-weight:800!important;background:linear-gradient(180deg,#ffd666,#f2b01e)!important;color:#3b2a00!important;border:0!important}

        .cd-sec{font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.6px;margin:14px 2px 6px}
        .cd-card{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:10px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .cd-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .cd-full{grid-column:1 / span 2}
        .cd-label{display:block;font-size:11px;font-weight:800;color:#162566;text-transform:uppercase;letter-spacing:.4px;margin-bottom:3px}
        .cd-inp{height:38px;border-radius:10px!important;font-weight:600;width:100%}
        .cd-sel{width:100%}
        .cd-sel .ant-select-selector{min-height:38px;border-radius:10px!important;align-items:center}
        .cd-date.ant-picker{height:38px;border-radius:10px!important;width:100%}
        .cd-ta{border-radius:10px!important;font-weight:600}
        .cd-err{display:block;color:#e53935;font-size:11px;font-weight:700;margin-top:2px}
        .cd-hint{display:block;color:#7b84a0;font-size:10.5px;font-weight:600;margin-top:2px}

        .cd-radio{display:flex;gap:10px}
        .cd-actions{margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .cd-btn{height:44px!important;border-radius:12px!important;font-weight:800!important;font-size:14px!important}
        .cd-cancel{background:#fff!important;border:1.5px solid #e53935!important;color:#e53935!important}
        .cd-save{background:linear-gradient(135deg,#162566,#2a3c8f)!important;border:0!important;color:#fff!important}
      `}</style>

      {/* Search by mobile (create mode only) */}
      {!isEdit && (
        <div className="cd-search">
          <div className="cd-search-in">
            <Input
              placeholder="Enter Mobile Number"
              className="cd-inp"
              ref={phone1Ref}
              autoFocus={true}
              inputMode="numeric"
              value={phoneNo}
              onFocus={(e) => e.target.select()}
              onKeyDown={handleMobileNoKeyDown}
              onChange={(e) => {
                const value = e.target.value.replace(/[a-zA-Z]/g, "");
                if (value.length <= 10) {
                  setPhoneNo(value);
                }
              }}
            />
          </div>
          <Button
            className="cd-search-btn"
            ref={searchRef}
            onClick={() => {
              mobileRef.current?.focus();
              if (/^\d{10}$/.test(phoneNo)) {
                userDetailsAPI();
              }
            }}
          >
            Search
          </Button>
        </div>
      )}

      {/* Contact */}
      <div className="cd-sec">Contact</div>
      <div className="cd-card">
        <div className="cd-grid">
          <div>
            <label className="cd-label">Mobile No. 1</label>
            <Input
              placeholder="Enter Mobile1"
              className="cd-inp"
              ref={mobileRef}
              autoFocus={true}
              inputMode="numeric"
              disabled={isEdit}
              value={formValues.mobile1}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange("mobile1", value);
                }
              }}
              onKeyDown={(e) => {
                handleKeyDown(e, cityRef);
              }}
            />
            {isEdit && (
              <span className="cd-hint">
                Mobile number can't be changed. It links the customer's ledger.
              </span>
            )}
            {errors.mobile1 && (
              <span className="cd-err">{errors.mobile1}</span>
            )}
          </div>

          <div>
            <label className="cd-label">City</label>
            <Input
              placeholder="Enter City"
              className="cd-inp"
              ref={cityRef}
              value={formValues.city}
              onChange={(e) => handleChange("city", e.target.value)}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => {
                handleKeyDown(e, nameRef);
              }}
            />
            {errors.city && <span className="cd-err">{errors.city}</span>}
          </div>

          <div>
            <label className="cd-label">Name</label>
            <Input
              placeholder="Enter Name"
              className="cd-inp"
              ref={nameRef}
              disabled={lockName}
              value={formValues.name}
              onChange={(e) => handleChange("name", e.target.value)}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => {
                handleKeyDown(e, phoneRef);
              }}
            />
            {lockName && (
              <span className="cd-hint">
                Name is locked while the customer has a balance.
              </span>
            )}
            {errors.name && <span className="cd-err">{errors.name}</span>}
          </div>

          <div>
            <label className="cd-label">Mobile No. 2</label>
            <Input
              placeholder="Enter Mobile2"
              className="cd-inp"
              ref={phoneRef}
              inputMode="numeric"
              value={formValues.mobile2}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange("mobile2", value);
                }
              }}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => {
                handleKeyDown(e, phone2Ref);
              }}
            />
          </div>

          <div className="cd-full">
            <label className="cd-label">Phone No.</label>
            <Input
              placeholder="Enter Phone No."
              className="cd-inp"
              ref={phone2Ref}
              inputMode="numeric"
              value={formValues.phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleChange("phone", value);
                }
              }}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => {
                handleKeyDown(e, addressRef);
              }}
            />
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="cd-sec">Address</div>
      <div className="cd-card">
        <Input.TextArea
          rows={4}
          className="cd-ta"
          ref={addressRef}
          value={[
            formValues.address1,
            formValues.address2,
            formValues.address3,
            formValues.address4,
          ].join("\n")}
          onChange={(e) => handleChange("address", e.target.value)}
          onKeyDown={(e) => {
            handleKeyDown(e, stateRef);
          }}
        />
      </div>

      {/* Tax & ID */}
      <div className="cd-sec">Tax &amp; ID</div>
      <div className="cd-card">
        <div className="cd-grid">
          <div>
            <label className="cd-label">State</label>
            <Select
              placeholder="Select State"
              className="cd-sel"
              ref={stateRef}
              value={formValues.state}
              onChange={(value) => {
                handleChange("state", value || "");
                setTimeout(() => {
                  gstRef?.current?.focus();
                }, 0);
              }}
              allowClear
              onKeyDown={(e) => {
                setTimeout(() => {
                  gstRef?.current?.focus();
                }, 0);
              }}
            >
              {stateList.map((item) => (
                <Option key={item.code} value={item.statename}>
                  {item.statename}
                </Option>
              ))}
            </Select>
            {errors.state && <span className="cd-err">{errors.state}</span>}
          </div>

          <div>
            <label className="cd-label">Code</label>
            <Input
              className="cd-inp"
              value={formValues.stateCode}
              disabled
            />
          </div>

          <div>
            <label className="cd-label">GSTIN</label>
            <Input
              placeholder="Enter GSTIN"
              className="cd-inp"
              ref={gstRef}
              value={formValues.gstin}
              onChange={(e) => handleChange("gstin", e.target.value)}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => {
                handleKeyDown(e, panRef);
              }}
            />
          </div>

          <div>
            <label className="cd-label">PAN No.</label>
            <Input
              className="cd-inp"
              value={formValues.panNo}
              ref={panRef}
              onChange={(e) => {
                // Convert to uppercase and restrict to 10 characters
                const value = e.target.value.toUpperCase().slice(0, 10);
                handleChange("panNo", value);
              }}
              placeholder="Enter PAN (e.g. ABCDE1234F)"
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => {
                handleKeyDown(e, idProfRef);
              }}
            />
          </div>

          <div className="cd-full">
            <label className="cd-label">ID Proof</label>
            <Select
              className="cd-sel"
              ref={idProfRef}
              value={formValues.idProof}
              onChange={(value) => {
                handleChange("idProof", value || "");
                setTimeout(() => {
                  dobRef?.current?.focus();
                }, 0);
              }}
              placeholder="Select ID Proof"
              allowClear
              onKeyDown={(e) => {
                setTimeout(() => {
                  dobRef?.current?.focus();
                }, 0);
              }}
            >
              <Option value="Aadhar">Aadhar</Option>
              <Option value="DRIVING LICENCE">Driving Licence</Option>
              <Option value="VOTER ID">Voter ID</Option>
              <Option value="PASSPORT">Passport</Option>
            </Select>
          </div>
        </div>
      </div>

      {/* Dates & location */}
      <div className="cd-sec">Dates &amp; Location</div>
      <div className="cd-card">
        <div className="cd-grid">
          <div>
            <label className="cd-label">D.O.B</label>
            <DatePicker
              className="cd-date"
              ref={dobRef}
              value={formValues.dob ? dayjs(formValues.dob) : null}
              onChange={(date) =>
                handleChange("dob", date ? date.toISOString() : null)
              }
              placeholder="Select D.O.B"
              maxDate={dayjs()}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
              onKeyDown={(e) => {
                handleKeyDown(e, anniversaryRef);
              }}
            />
          </div>

          <div>
            <label className="cd-label">Anniversary</label>
            <DatePicker
              className="cd-date"
              ref={anniversaryRef}
              value={
                formValues.anniversary ? dayjs(formValues.anniversary) : null
              }
              onChange={(date) =>
                handleChange("anniversary", date ? date.toISOString() : null)
              }
              placeholder="Select Anniversary"
              maxDate={dayjs()}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
              onKeyDown={(e) => {
                handleKeyDown(e, saveRef);
              }}
            />
          </div>

          <div className="cd-full" style={{ marginTop: 4 }}>
            <Radio.Group
              className="cd-radio"
              onChange={(e) => handleChange("locationType", e.target.value)}
              value={formValues.locationType}
            >
              <Radio value="OUTSTATION">Out Station</Radio>
              <Radio value="LOCAL">Local</Radio>
            </Radio.Group>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="cd-actions">
        <Button
          className="cd-btn cd-cancel"
          onClick={() => {
            onCancel();
            setErrors({});
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="cd-btn cd-save"
          ref={saveRef}
          onClick={handleSave}
        >
          {isEdit ? "Update" : "Save"}
        </Button>
      </div>
    </Modal>
  );
};

export default CustomerDialog;